import { api } from "@/api"
import { queryClient } from "@/queryClient"

export const activateUser = async (userId: string) => {
  await api.post(`/users/${userId}/activate/`)
  queryClient.invalidateQueries([BASE_USERS_QUERY_KEY])
}
